import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCube = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon / cube",
		children: /* @__PURE__ */ _jsx("path", {
			id: "icon",
			d: "M21.406 6.08601L12.406 2.08601C12.278 2.02914 12.1395 1.99976 11.9995 1.99976C11.8595 1.99976 11.721 2.02914 11.593 2.08601L2.593 6.08601C2.573 6.09501 2.559 6.11001 2.539 6.12101C2.511 6.13501 2.481 6.14401 2.455 6.16101C2.433 6.17601 2.416 6.19501 2.395 6.21101C2.3219 6.26533 2.25779 6.3308 2.205 6.40501C2.185 6.43301 2.164 6.45801 2.146 6.48601C2.11624 6.53886 2.09082 6.59404 2.07 6.65101C2.061 6.67801 2.047 6.70301 2.039 6.73001C2.01389 6.81784 2.00077 6.90866 2 7.00001V17C2 17.396 2.232 17.753 2.594 17.914L11.594 21.914C11.724 21.972 11.862 22 12 22C12.1392 21.9964 12.2762 21.9637 12.402 21.904L12.406 21.914L21.406 17.914C21.5829 17.8356 21.7332 17.7074 21.8386 17.5452C21.9441 17.3829 22.0002 17.1935 22 17V7.00001C22.0002 6.8065 21.9441 6.61711 21.8386 6.45485C21.7332 6.2926 21.5829 6.16446 21.406 6.08601ZM12 4.09501L18.538 7.00001L12 9.90501L5.463 7.00001L12 4.09501ZM4 16.351V8.53901L11 11.65V19.461L4 16.351ZM13 19.461V11.65L20 8.53901V16.351L13 19.461Z",
			fill: "currentColor"
		})
	})
});
export default SvgCube;
